import { Getter } from "vuex";
import { ISelectedFilter, IState } from './state';
import moment from 'moment';
let locale = document.documentElement.lang;
moment.locale(locale);

const numberToShow: Getter<IState, IState> = (state) => state.numberToShow;
const total: Getter<IState, IState> = (state) => state.total;
const items: Getter<IState, IState> = (state) => state.items;
const sort: Getter<IState, IState> = (state) => state.sort;
const start: Getter<IState, IState> = (state) => state.start;
const end: Getter<IState, IState> = (state) => state.end;
const operations: Getter<IState, IState> = (state) => state.operations;
//const professions: Getter<IState, IState> = (state) => state.professions;
const subjects: Getter<IState, IState> = (state) => state.subjects;
const themes: Getter<IState, IState> = (state) => state.themes;
const articleForm: Getter<IState, IState> = (state) => state.articleForm;
const blogNames : Getter<IState, IState> = (state) => state.blogNames;
const selectedFilters : Getter<IState, IState> = (state) => {
	let selectedF: ISelectedFilter[] = [];
	state.tags.forEach(tag => {
		tag.options.forEach(option => {
			if(option.selected) {
				selectedF.push({
					name: tag.name,
					option: {
						name: option.name,
						title: option.title,
						selected: option.selected
					}
				})
			}
		})
	})
	if(state.start && state.end) {
		selectedF.push({
			name: 'dates',
			option: {
				name: moment(state.start).format('YYYY-MM-DD') + ' - ' +  moment(state.end).format('YYYY-MM-DD'),
				title: moment(state.start).format('YYYY-MM-DD') + ' - ' +  moment(state.end).format('YYYY-MM-DD'),
				selected: true,
			}
		})
	}
	return selectedF;
};
const selectedTypes: Getter<IState, IState> = (state) => state.selectedTypes;
const selectedSort: Getter<IState, IState> = (state) => state.selectedSort;

export default {
	articleForm,
	numberToShow,
	total,
	items,
	sort,
	start,
	end,
	operations,
	//professions,
	subjects,
	themes,
	blogNames,
	selectedFilters,
	selectedTypes,
	selectedSort
}
